import { Link } from 'react-router-dom';
import { tokens } from '../../theme';
import { Pegasus } from '../DreamlinkMark';

type NavTheme = 'blue' | 'night';

// Maroon brand accent on light surfaces; cream on dark (night) surfaces.
const MAROON = '#590b11';
const CREAM = '#F5F2EE';

export function PublicNav({
  onDarkHero = false,
  theme = 'blue',
}: {
  onDarkHero?: boolean;
  theme?: NavTheme;
}) {
  const night = theme === 'night';

  const fg = night ? CREAM : onDarkHero ? '#fff' : tokens.color.ink[900];
  const accent = night ? CREAM : MAROON;
  const accentInk = night ? MAROON : CREAM;
  const bg = night
    ? onDarkHero
      ? 'transparent'
      : 'rgba(26,6,8,0.85)'
    : onDarkHero
      ? 'transparent'
      : 'rgba(245,242,238,0.94)';
  const blur = onDarkHero ? 'none' : 'saturate(160%) blur(12px)';
  const border = onDarkHero
    ? 'none'
    : `1px solid ${night ? '#4a1a1d' : tokens.color.line[100]}`;

  return (
    <nav
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        padding: '16px 28px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: fg,
        background: bg,
        backdropFilter: blur,
        WebkitBackdropFilter: blur,
        borderBottom: border,
        transition: 'background 240ms ease, color 240ms ease, border-color 240ms ease',
      }}
    >
      <Link
        to="/"
        style={{ display: 'inline-flex', alignItems: 'center', gap: 10, color: 'inherit' }}
      >
        <Pegasus size={22} color="currentColor" />
        <span
          style={{
            fontFamily: "'Archivo', 'DM Sans', sans-serif",
            fontWeight: 700,
            fontSize: 16,
            letterSpacing: '0.02em',
            lineHeight: 1,
          }}
        >
          Dreamlink{' '}
          <span style={{ fontWeight: 400, opacity: 0.7 }}>
            Studio
          </span>
        </span>
      </Link>

      <ul
        style={{
          display: 'flex',
          gap: 26,
          listStyle: 'none',
          alignItems: 'center',
          fontSize: 12,
          fontWeight: 500,
        }}
        className="ls-nav-links"
      >
        <li className="ls-nav-hide-mobile">
          <Link to="/clipping" style={{ color: 'inherit' }}>
            Clipping
          </Link>
        </li>
        <li className="ls-nav-hide-mobile">
          <Link to="/localization" style={{ color: 'inherit' }}>
            Localization
          </Link>
        </li>
        <li className="ls-nav-hide-mobile">
          <Link to="/inquire" style={{ color: 'inherit' }}>
            For brands
          </Link>
        </li>
        <li>
          <Link
            to="/clipper"
            style={{
              padding: '9px 17px',
              background: accent,
              color: accentInk,
              borderRadius: 999,
              letterSpacing: '0.02em',
              fontWeight: 600,
            }}
          >
            Start clipping
          </Link>
        </li>
      </ul>
    </nav>
  );
}
